import React from "react";

export const Loader = () => (
  <div className="text-lg max-w-prose mb-2 pb-8 text-gray-400 mx-auto">
    Loading...
  </div>
);